import * as React from "react";
import {Suspense, useEffect, useRef, useState} from "react";
// @ts-ignore
import ReactDOM from "react-dom/client";

import {resolve} from "./utils/resolve";
import {FullscreenToggle} from "./components/FullscreenToggle";
import {IGlobalContext} from "./gameLoader/types/IGlobalContext.types";
import { TypeShellFeatureType } from "./types";

declare const process: {
  env: {
    BASH_VERSION?: string;
  };
};

if (console.warn && process.env.BASH_VERSION) {
  console.warn(`Bash version: ${process.env.BASH_VERSION}`);
}

/**
 * {
 *     baseUrl: '/aux/games/aux_b/runner/index.html',
 *     platform: 'desk',
 *     gameName: 'super_sticky_piggy',
 *     lang: 'en',
 *     key: '38baa8288d5b3534d6a2f5bf22608189',
 *
 *     enable_features: 'replay',
 *     replay_url: 'http://localhost:3200/api/rounds/bng',
 *     replay_server_url: 'http://localhost:3200/api/replay/bng',
 *
 *     in_game_lobby_url: 'https://gsc-rc.newreels.tech/lobby',
 *     authLobby: JSON.stringify({
 *         token: "b7927e2efff3b664b4242a0601dd28cf"
 *     }),
 *   }
 */

const Container = () => {
    const [config, setConfig] = useState<TypeShellFeatureType | undefined>(undefined);
    const refContent = useRef(null);

    useEffect(  () => {
        const configUpdated = async(event: CustomEvent<IGlobalContext>) => {
            const details: TypeShellFeatureType | undefined = resolve(event.detail, e => e.configs, undefined);
            if (!details) {
                setConfig(undefined);
                return;
            }
            // task GT-5066 - hide lobby icon if GET[in_game_lobby] == '0'
            if (details['in_game_lobby_url'] && details['in_game_lobby'] === '0') {
                delete details['in_game_lobby_url'];
            }

            setConfig({
                ...details || {},
                authLobby: JSON.stringify({
                    token: details.in_game_lobby_token || details.key
                }),
            });
        };

        const onGestureStart = (e: Event) => {
            e.preventDefault();
        };

        document.addEventListener("gesturestart", onGestureStart);
        window.addEventListener('config-updated', configUpdated);
        window.dispatchEvent(new CustomEvent('send-config'));

        return () => {
            window.removeEventListener('config-updated', configUpdated);
            document.removeEventListener("gesturestart", onGestureStart);
        }
    }, []);

    return (
        <div className={"features"} ref={refContent}>
            { config?.platform === 'mob' && config?.debug !== '1' && <FullscreenToggle target={refContent} isFullscreenEnabled={!(config?.nofullscreen === 'true')} />}
        </div>
    )
};

const rootElement = document.getElementById("root");
if (rootElement) {
  const root = ReactDOM.createRoot(rootElement);
  root.render(
      <Suspense fallback={<h1>Loading...</h1>}>
        <Container />
      </Suspense>
  );
}
